import { postData } from "./apis";

const path = "/reports";

export const getBranchTranListApi = (value) => {
  let endPoint = `${path}/get-branch-trans-transfer-list`;
  return postData(endPoint, value);
};

export const getBranchBalanceApi = (value) => {
  let endPoint = `${path}/get-branch-balance`;
  return postData(endPoint, value);
};

export const getBranchTransactionPendingListApi = (value) => {
  let endPoint = `${path}/get-branch-trans-pending-list`;
  return postData(endPoint, value);
};

export const getItemWiseReportApi = (value) => {
  let endPoint = `${path}/get-item-wise-profit`;
  return postData(endPoint, value);
};

export const getBalanceSheetApi = (value) => {
  let endPoint = `${path}/get-balance-sheet`;
  return postData(endPoint, value);
};

export const getAdvanceCreditorBalanceApi = (value) => {
  let endPoint = `${path}/get-advance-creditor-balance`;
  return postData(endPoint, value);
};

export const getAccountLedgerApi = (value) => {
  let endPoint = `${path}/get-account-ledger`;
  return postData(endPoint, value);
};
export const getIntangibleAssetLedgerApi = (value) => {
  const endPoint = `${path}/get-intangible-asset-ledger`;
  return postData(endPoint, value);
};
export const getCapitalLedgerApi = (value) => {
  let endPoint = `${path}/get-capital-ledger`;
  return postData(endPoint, value);
};

export const getSalesProfitLossApi = (value) => {
  let endPoint = `${path}/get-sales-profit-loss`;
  return postData(endPoint, value);
};

export const getProductProfitLossApi = (value) => {
  let endPoint = `${path}/get-product-profit-loss`;
  return postData(endPoint, value);
};

export const getBranchLedgerApi = (value) => {
  let endPoint = `${path}/get-branch-ledger`;
  return postData(endPoint, value);
};

export const getBranchTransactionReciveListApi = (value) => {
  let endPoint = `${path}/get-branch-trans-receive-list`;
  return postData(endPoint, value);
};

export const getCustomerCountApi = (value) => {
  let endPoint = `${path}/get-customer-count`;
  return postData(endPoint, value);
};

export const getCapitalBalanceApi = (value) => {
  let endPoint = `${path}/get-capital-balance`;
  return postData(endPoint, value);
};

export const getdebitorLedgerApi = (value) => {
  let endPoint = `${path}/get-debitor-ledger`;
  return postData(endPoint, value);
};

export const getCreditorLedgerApi = (value) => {
  let endPoint = `${path}/get-creditor-ledger`;
  return postData(endPoint, value);
};

export const getDailyLedgerApi = (value) => {
  let endPoint = `${path}/get-daily-ledger`;
  return postData(endPoint, value);
};

export const getDebitorLedgerOwnApi = (value) => {
  let endPoint = `${path}/get-debitor-ledger-own`;
  return postData(endPoint, value);
};

export const getIndirectExpenseLedgerApi = (value) => {
  let endPoint = `${path}/get-indirect-expense-ledger`;
  return postData(endPoint, value);
};

export const getFixedAssetLedgerApi = (value) => {
  let endPoint = `${path}/get-fixed-asset-ledger`;
  return postData(endPoint, value);
};

export const getFixedAssetBalanceApi = (value) => {
  let endPoint = `${path}/get-fixed-asset-balance`;
  return postData(endPoint, value);
};
export const getIntangibleAssetBalanceApi  = (value) => {
  let endPoint = `${path}/get-intangible-asset-balance`;
  return postData(endPoint, value);
};
export const getDirectIncomeLedgerApi = (value) => {
  let endPoint = `${path}/get-direct-income-ledger`;
  return postData(endPoint, value);
};

export const getDirectIncomeBalanceApi = (value) => {
  let endPoint = `${path}/get-direct-income-balance`;
  return postData(endPoint, value);
};

export const getDirecteExpenseLedgerApi = (value) => {
  let endPoint = `${path}/get-direct-expense-ledger`;
  return postData(endPoint, value);
};

export const getDirecteExpenseBalanceApi = (value) => {
  let endPoint = `${path}/get-direct-expense-balance`;
  return postData(endPoint, value);
};

export const getLoanLedgerApi = (value) => {
  let endPoint = `${path}/get-loan-ledger`;
  return postData(endPoint, value);
};

export const getLoanBalanceApi = (value) => {
  let endPoint = `${path}/get-loan-balance`;
  return postData(endPoint, value);
};

export const getIndireactIncomeLedgerApi = (value) => {
  let endPoint = `${path}/get-indirect-income-ledger`;
  return postData(endPoint, value);
};

export const getTrialBalanceApi = (value) => {
  let endPoint = `${path}/get-trial-balance`;
  return postData(endPoint, value);
};

export const getTaxLedgerApi = (value) => {
  let endPoint = `${path}/get-tax-ledger`;
  return postData(endPoint, value);
};

export const getCustomerCollectionBalanaceApi = (value) => {
  let endPoint = `${path}/get-customer-collection-balance`;
  return postData(endPoint, value);
};

export const getServiceLedgerApi = (value) => {
  let endPoint = `${path}/get-service-ledger`;
  return postData(endPoint, value);
};

export const getServiceExpenseLedgerApi = (value) => {
  let endPoint = `${path}/get-service-expense-ledger`;
  return postData(endPoint, value);
};

export const getSalesLedgerApi = (value) => {
  let endPoint = `${path}/get-sales-ledger`;
  return postData(endPoint, value);
};

export const getPurchaseLedgerApi = (value) => {
  let endPoint = `${path}/get-purchase-ledger`;
  return postData(endPoint, value);
};

export const getSalesReturnLedgerApi = (value) => {
  let endPoint = `${path}/get-sales-return-ledger`;
  return postData(endPoint, value);
};

export const getPurchaseReturnLedgerApi = (value) => {
  let endPoint = `${path}/get-purchase-return-ledger`;
  return postData(endPoint, value);
};

export const getAdvanceDebitorBalanceApi = (value) => {
  let endPoint = `${path}/get-advance-debitor-balance`;
  return postData(endPoint, value);
};

export const approveBranchTranApi = (value) => {
  let endPoint = `${path}/approve-branch-tran`;
  return postData(endPoint, value);
};

export const getBranchTransReportApi = (value) => {
  let endPoint = `${path}/get-branch-trans-report`;
  return postData(endPoint, value);
};

export const getInvestmentBalanceApi = (value) => {
  let endPoint = `${path}/get-investment-balance`;
  return postData(endPoint, value);
};

export const getCurrentAssetBalanceApi = (value) => {
  let endPoint = `${path}/get-current-asset-balance`;
  return postData(endPoint, value);
};

export const getDepositAccountBalanceApi = (value) => {
  let endPoint = `${path}/get-deposit-account-balance`;
  return postData(endPoint, value);
};

export const getCurrentLiabilityBalanceApi = (value) => {
  let endPoint = `${path}/get-current-liability-balance`;
  return postData(endPoint, value);
};

export const getCurrentAssetLedgerApi = (value) => {
  let endPoint = `${path}/get-current-asset-ledger`;
  return postData(endPoint, value);
};

export const getCurrentLiabilityLedgerApi = (value) => {
  let endPoint = `${path}/get-current-liability-ledger`;
  return postData(endPoint, value);
};

export const getDepositAccountLedgerApi = (value) => {
  let endPoint = `${path}/get-deposit-account-ledger`;
  return postData(endPoint, value);
};

export const getInverstmentLedgerApi = (value) => {
  let endPoint = `${path}/get-investment-ledger`;
  return postData(endPoint, value);
};

export const getSuspenseBalanceApi = (value) => {
  let endPoint = `${path}/get-suspense-balance`;
  return postData(endPoint, value);
};

export const getSuspenseLedgerApi = (value) => {
  let endPoint = `${path}/get-suspense-ledger`;
  return postData(endPoint, value);
};

export const getReserveSurplusBalanceApi = (value) => {
  let endPoint = `${path}/get-reserve-surplus-balance`;
  return postData(endPoint, value);
};

export const getReserveSurplusLedgerApi = (value) => {
  let endPoint = `${path}/get-reserve-surplus-ledger`;
  return postData(endPoint, value);
};